module.exports = __webpack_public_path__ + "img/cassava.c8fed9ca.jpg";